import { isSSR } from '@k2/core/util'
import { defineStore } from 'pinia'
import { ref } from 'vue'
import { type RecentCampaign, useCampaignsResource } from '../resources'

export const useRecentCampaignStore = defineStore('recent-campaigns', () => {
  const { getRecentCampaigns } = useCampaignsResource()
  const recent = ref<RecentCampaign[]>([])
  let loadedOrganizationId: string | undefined

  const load = async (organizationId: string) => {
    if (isSSR) return
    if (loadedOrganizationId !== organizationId) recent.value = []
    loadedOrganizationId = organizationId
    const { data } = await getRecentCampaigns(organizationId)
    if (data && loadedOrganizationId === organizationId) recent.value = data
  }

  return { recent, load }
})
